// ./src/components/Header.jsx
import React from "react";
import { Sparkles, Zap } from "lucide-react";

const Header = () => {
  return (
    <header className="glass-header sticky top-0 z-50 border-b border-white/20">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo - Moderner mit Gradient */}
          <div className="flex items-center space-x-3 group">
            <div className="relative">
              <div className="w-10 h-10 rounded-2xl bg-gradient-to-br from-primary-600 to-primary-500 flex items-center justify-center shadow-color transform group-hover:scale-110 transition-all duration-300">
                <Sparkles className="w-6 h-6 text-white" />
              </div>
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-accent-emerald-500 rounded-full flex items-center justify-center animate-pulse-glow">
                <Zap className="w-2 h-2 text-white" />
              </div>
            </div>
            <div>
              <h1 className="text-xl font-bold text-gradient group-hover:scale-105 transition-transform duration-300">
                SmartMeet
              </h1>
              <p className="text-xs text-neutral-500 -mt-1">AI Powered</p>
            </div>
          </div>

          {/* Status Badge - Einfacher ohne Mock-Daten */}
          <div className="hidden md:flex items-center">
            <div className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-emerald-50 to-cyan-50 border border-emerald-200 rounded-xl">
              <div className="w-2 h-2 bg-accent-emerald-500 rounded-full animate-pulse"></div>
              <span className="text-sm font-medium text-emerald-700">
                AI Meeting Analysis
              </span>
            </div>
          </div>

          {/* Mobile Badge */}
          <div className="md:hidden">
            <div className="w-3 h-3 bg-accent-emerald-500 rounded-full animate-pulse-glow"></div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
